import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Axios from "axios";

import { url } from "../../../../config/config";
import { useStyles } from "./BookSidebar.css";

class AuthorList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      author: [],
    };
  }

  componentDidMount() {
    this.getAuthorList();
  }

  getAuthorList = async () => {
    const response = await Axios.get(`${url}/api/authors`);
    if (response.data.length !== 0) {
      this.setState({
        author: response.data,
      });
    }
  };

  handleClick = (authorId) => {
    this.props.history.push(`/books/category/author/${authorId}`);
  };

  render() {
    const { classes } = this.props;
    this.state.author.sort(() => Math.random() - 0.5);
    return (
      <div className={classes.root}>
        <h3>Author</h3>
        {this.state.author.slice(0, 5).map((author, index) => (
          <div
            key={index}
            className={classes.labelStyle}
            onClick={() => this.handleClick(author._id)}
          >
            <p>
              {author.firstName} {author.lastName}
            </p>
          </div>
        ))}
        <Link to="/books/category/author" className={classes.linkStyle}>
          See More...
        </Link>
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(AuthorList));
